import React from "react";

import "../../../styles/tutorial.scss";

function LotinhaDivertidu({ name }) {
  return (
    <div class="container_como_jogar">
      <div>
        <h1 className="center capitalize">{name}</h1>

        <p>
          Já pensou em ganhar até R$120.000,00 mil concorrendo em sorteios a
          cada 1 hora, pagando apenas R$1,00 real? A{" "}
          <b className="capitalize">{name}</b> é a modalidade ideal para você.
        </p>
        <p>
          Serão sorteados 15 números, entre 01 e 25. Apostando R$1,00 real você
          poderá escolher de 17 a 23 dezenas e a premiação é baseada na
          quantidade de dezenas escolhidas e no valor apostado.
        </p>
      </div>
    </div>
  );
}

export default LotinhaDivertidu;



// WEBPACK FOOTER //
// ./src/static/tutorial/concurso/lotinha-divertidu.jsx